import React from "react";

import AddOccurrence from "./AddOccurrence";
import AddIcon from "../../Common/AddIcon";

const AddOccurrenceDialog = (props) => {
  const { timeSlots, initialDate, refresh, type } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <AddIcon handleClick={() => setOpen(true)} />
      {open && (
        <AddOccurrence
          open={open}
          setOpen={setOpen}
          timeSlots={timeSlots}
          initialDate={initialDate}
          refresh={refresh}
          type={type}
        />
      )}
    </>
  );
};

export default AddOccurrenceDialog;
